export const applyIf = <T>(condition: boolean, fnIfTrue: (value: T) => T, fnIfFalse: (value: T) => T) =>
  condition ? fnIfTrue : fnIfFalse;

export const isPresent = <T>(value: T | undefined | null): value is T => value !== undefined && value !== null;

export const pipe =
  <T>(...fns: Array<(arg: T) => T>) =>
  (value: T): T =>
    fns.reduce((acc, fn) => fn(acc), value);
